import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { QueueScreen } from "../screens/QueueScreen";
import { reviewSearch } from "../screens/salesSearch";

export const Route = createFileRoute("/prototype/c/$companyId/review")({
  validateSearch: (search) => reviewSearch.parse(search),
  component: ReviewQueue,
});

function ReviewQueue() {
  const { companyId } = Route.useParams();
  const { type, item } = Route.useSearch();
  return (
    <QueueScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      type={type}
      itemId={item}
    />
  );
}
